/*************************************************/
/* HEADER                                        */
/*************************************************/
export function header(body) {
    let headerElement;
    const headerSelector = '.header',
        headerStickyClass = 'header-sticky',
        enterEvents = ['focusin', 'mouseover'],
        exitEvents = ['focusout', 'mouseleave'];

    const setStickyHeader = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop
        if (top > headerElement.offsetHeight / 2) {
            body.classList.add(headerStickyClass);
        } else {
            body.classList.remove(headerStickyClass);
        }
    }

    const init = () => {
        headerElement = document.querySelector(headerSelector);
        var exitTimer;

        enterEvents.forEach(eventName => {
            headerElement.addEventListener(eventName, () => {
                clearTimeout(exitTimer);
                body.classList.add('header-active');
            });
        });

        exitEvents.forEach(eventName => {
            headerElement.addEventListener(eventName, e => {
                const eventPath = e.composedPath();
                if (eventPath[0].classList.contains('header') || !eventPath.some(element => element.classList.contains('header'))) {
                    clearTimeout(exitTimer);
                    exitTimer = setTimeout(function () {
                        document.activeElement.blur();
                        body.classList.remove('header-active');
                    }, 300);
                }
            });
        })

        // Sticky header
        setStickyHeader();
        window.addEventListener('scroll', e => {
            setStickyHeader();
        });

    };

    init();

}

